import React, { useCallback, useEffect, useState } from "react";
import { TextField, IconButton } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Autocomplete from '@mui/material/Autocomplete';
import ExpandMore from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import { costomEllipsis } from "../../Uitls/Util";
import { MultiSelectList } from "./MultiSelectList";
import { getIndicationsList } from "../../services/apis";

const IndicationFilter = ({
  value,
  onChange,
  label = "Indication",
  disabled = false,
  required = false,
}) => {
  const [indicationOptions, setIndicationOptions] = useState([]);
  const [indicationValue, setIndicationValue] = useState([]);
  const [optionsToDisplay, setOptionsToDisplay] = useState([]);
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    getIndicationsList((response, err, errorCode) => {
      if (response && response.status === 200) {
        const data = response.data || [];
        const mapped = data
          .filter(
            (item) => item && (item.indicationName || item.label || item.name)
          )
          .map((item) => ({
            id: item.id || item.name || item.indicationName,
            displayName: item.label || item.indicationName || item.name,
            name: item.name || item.indicationName || item.id,
            label: item.label || item.indicationName || item.name,
          }));
        setIndicationOptions(mapped);
        setOptionsToDisplay(mapped);
      } else {
        console.error("Failed to fetch indications", err || errorCode);
      }
    });
  }, []);

  useEffect(() => {
    const q = (searchText || "").toLowerCase();
    setOptionsToDisplay(
      indicationOptions.filter((el) =>
        el?.displayName?.toLowerCase().includes(q)
      )
    );
  }, [searchText, indicationOptions]);

  useEffect(() => {
    if (!open && searchText?.length > 0) setSearchText("");
  }, [open, searchText]);

  useEffect(() => {
    if (Array.isArray(value)) {
      setIndicationValue(value);
      if (value.length === 0) setSearchText("");
    }
  }, [value]);

  // const useStyles = makeStyles(() => ({
  //   paper: { overflowY: "hidden", fontSize: 12 },
  //   autocomplete: {
  //     fontFamily: "Nunito, sans-serif !important",
  //     "& .MuiAutocomplete-inputRoot": {
  //       height: 42,
  //       marginBottom: 16,
  //       fontSize: 12,
  //     },
  //     "& .MuiFilledInput-input::placeholder": {
  //       color: "#8A8A8A",
  //       opacity: 1,
  //     },
  //     "& .MuiFilledInput-root": {
  //       backgroundColor: "#ffffff",
  //       height: 42,
  //       fontSize: 12,
  //       border: "solid 1px #d4d4d4",
  //       paddingRight: "96px !important",
  //       paddingLeft: "8px !important",
  //       borderRadius: 6,
  //       paddingBottom: 0,
  //       paddingTop: 12,
  //       display: "flex",
  //       alignItems: "flex-start",
  //       cursor: "text",
  //     },
  //     "& .MuiFilledInput-root:hover": { backgroundColor: "#ffffff" },
  //     "& .MuiFilledInput-input": {
  //       lineHeight: "20px",
  //       height: 20,
  //       transition: "none",
  //       paddingRight: 5,
  //       padding: "0 !important",
  //       color: "#000000",
  //       marginTop: 8,
  //       boxSizing: "border-box",
  //     },
  //     "& .MuiInputLabel-formControl": {
  //       top: "-4px",
  //       zIndex: 1,
  //     },
  //     "& .MuiFilledInput-underline :focus": { borderBottom: "none" },
  //     "& .MuiFilledInput-underline:before": { borderBottom: "none" },
  //     "& .MuiFilledInput-underline:after": { borderBottom: "none" },
  //     "& .MuiFilledInput-underline:hover:before": { borderBottom: "none" },
  //     "& .MuiSelect-select:focus": { borderRadius: 6 },
  //     "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
  //       transform: " translate(9px, 12px) scale(0.75)",
  //     },
  //     "& .MuiInputBase-root.Mui-disabled": { border: "none !important" },
  //     "& .MuiAutocomplete-clearIndicator": { display: "none" },
  //     "& .MuiAutocomplete-tag": { backgroundColor: "#e3f2fd" },
  //     "& .MuiFormLabel-asterisk": { color: "#e32b35" },
  //     "& .MuiFormLabel-root": {
  //       fontSize: 12,
  //       color: "#1E1E1E",
  //       fontWeight: 400,
  //       fontFamily: "Nunito, sans-serif !important",
  //       top: "-5.7px !important",
  //       zIndex: 2,
  //     },
  //     "& .MuiAutocomplete-endAdornment": { display: "none" },
  //     "& .MuiAutocomplete-popupIndicator": { display: "none" },
  //   },
  //   selectedText: {
  //     color: "#231F20",
  //     fontSize: 12,
  //     fontFamily: "Nunito, sans-serif",
  //     fontWeight: "normal",
  //     marginRight: 4,
  //     lineHeight: "20px",
  //     whiteSpace: "nowrap",
  //     overflow: "hidden",
  //     textOverflow: "ellipsis",
  //     maxWidth: "100%",
  //     marginTop: 8,
  //     height: 20,
  //     display: "flex",
  //     alignItems: "center",
  //     marginLeft: 0,
  //   },
  //   listbox: {
  //     maxHeight: 200,
  //     overflowY: "auto",
  //     scrollbarWidth: "thin",
  //     scrollbarColor: "#C8CDD4 transparent",
  //     "&::-webkit-scrollbar": { width: 6 },
  //     "&::-webkit-scrollbar-thumb": {
  //       backgroundColor: "#C8CDD4",
  //       borderRadius: 8,
  //       minHeight: 24,
  //     },
  //     "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#AEB5BE" },
  //     "&::-webkit-scrollbar-track": { background: "transparent" },
  //     "&::-webkit-scrollbar-button": { display: "none !important" },
  //     "& .MuiAutocomplete-option, \
  //      & .MuiMenuItem-root, \
  //      & .MuiListItem-root, \
  //      & li[role='option'], \
  //      & div[role='option']": {
  //       borderBottom: "none !important",
  //     },
  //     "& .MuiDivider-root": { display: "none !important" },
  //   },
  //   countPill: {
  //     display: "inline-flex",
  //     alignItems: "center",
  //     justifyContent: "center",
  //     width: 20,
  //     height: 16,
  //     borderRadius: 16,
  //     backgroundColor: "#F0F5F8",
  //     color: "#203662",
  //     fontWeight: 700,
  //     fontSize: 11,
  //     lineHeight: "16px",
  //     userSelect: "none",
  //   },
  //   endPill: { marginRight: 6 },
  //   clearBtn: {
  //     padding: 4,
  //     borderRadius: 6,
  //     "& svg": { fontSize: 18, color: "#203662" },
  //     "&:hover svg": { opacity: 0.9 },
  //   },
  //   dropdownBtn: {
  //     padding: 4,
  //     borderRadius: 6,
  //     "& svg": { fontSize: 20, color: "#203662" },
  //     "&:hover svg": { opacity: 0.9 },
  //   },
  //   endAdornmentContainer: {
  //     position: "absolute",
  //     right: 4,
  //     top: "50%",
  //     transform: "translateY(-50%)",
  //     display: "flex",
  //     alignItems: "center",
  //     gap: 2,
  //     pointerEvents: "auto",
  //   },
  // }));

  // const useStyles = makeStyles(() => ({
  //   paper: { overflowY: "hidden", fontSize: 12 },

  //   autocomplete: {
  //     fontFamily: "Nunito, sans-serif !important",

  //     "& .MuiAutocomplete-inputRoot": {
  //       height: 42,
  //       marginBottom: 16,
  //       fontSize: 12,
  //       flexWrap: "nowrap", // keep single line
  //       position: "relative", // anchor for absolute adornment
  //     },

  //     // ✅ Make sure the tags container (startAdornment) stays visible + single-line
  //     "& .MuiAutocomplete-startAdornment": {
  //       maxWidth: "calc(100% - 0px)", // leave room for +N, clear, chevron
  //       overflow: "hidden",
  //       whiteSpace: "nowrap",
  //       textOverflow: "ellipsis",
  //       flexWrap: "nowrap",
  //       display: "flex",
  //       alignItems: "center",
  //       gap: 4,
  //       pointerEvents: "none", // clicks go to input
  //     },

  //     "& .MuiFilledInput-input::placeholder": {
  //       color: "#8A8A8A",
  //       opacity: 1,
  //     },

  //     "& .MuiFilledInput-root": {
  //       backgroundColor: "#ffffff",
  //       height: 42,
  //       fontSize: 12,
  //       border: "solid 1px #d4d4d4",
  //       paddingRight: "96px !important", // reserve space for custom end adornment
  //       paddingLeft: "8px !important",
  //       borderRadius: 6,
  //       paddingBottom: 0,
  //       paddingTop: 10,
  //       display: "flex",
  //       alignItems: "flex-start",
  //       cursor: "text",
  //     },

  //     "& .MuiFilledInput-root:hover": { backgroundColor: "#ffffff" },

  //     "& .MuiFilledInput-input": {
  //       lineHeight: "20px",
  //       height: 20,
  //       transition: "none",
  //       paddingRight: 5,
  //       padding: "0 !important",
  //       color: "#000000",
  //       marginTop: 8,
  //       boxSizing: "border-box",
  //       minWidth: 0, // allow shrinking; avoids overlap
  //     },

  //     "& .MuiAutocomplete-input": { minWidth: 0 },

  //     "& .MuiInputLabel-formControl": { top: "-4px", zIndex: 1 },

  //     "& .MuiFilledInput-underline :focus": { borderBottom: "none" },
  //     "& .MuiFilledInput-underline:before": { borderBottom: "none" },
  //     "& .MuiFilledInput-underline:after": { borderBottom: "none" },
  //     "& .MuiFilledInput-underline:hover:before": { borderBottom: "none" },

  //     "& .MuiSelect-select:focus": { borderRadius: 6 },

  //     "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
  //       transform: " translate(9px, 12px) scale(0.75)",
  //     },

  //     "& .MuiInputBase-root.Mui-disabled": { border: "none !important" },

  //     "& .MuiAutocomplete-clearIndicator": { display: "none" },

  //     // We don’t rely on default chips, but keep this harmless
  //     "& .MuiAutocomplete-tag": {
  //       backgroundColor: "#e3f2fd",
  //       maxWidth: "calc(100% - 0px)",
  //       overflow: "hidden",
  //       textOverflow: "ellipsis",
  //       whiteSpace: "nowrap",
  //       padding: 0,
  //       margin: 0,
  //     },

  //     "& .MuiFormLabel-asterisk": { color: "#e32b35" },

  //     "& .MuiFormLabel-root": {
  //       fontSize: 12,
  //       color: "#1E1E1E",
  //       fontWeight: 400,
  //       fontFamily: "Nunito, sans-serif !important",
  //       top: "-5.7px !important",
  //       zIndex: 2,
  //     },

  //     "& .MuiAutocomplete-endAdornment": { display: "none" },
  //     "& .MuiAutocomplete-popupIndicator": { display: "none" },
  //   },

  //   selectedText: {
  //     color: "#231F20",
  //     fontSize: 12,
  //     fontFamily: "Nunito, sans-serif",
  //     fontWeight: "normal",
  //     marginRight: 4,
  //     lineHeight: "20px",
  //     whiteSpace: "nowrap",
  //     overflow: "hidden",
  //     textOverflow: "ellipsis",
  //     maxWidth: "calc(100% - 0px)", // don’t overlap custom end adornment
  //     marginTop: 8,
  //     height: 20,
  //     display: "flex",
  //     alignItems: "center",
  //     marginLeft: 0,
  //     zIndex: 3,
  //     pointerEvents: "none",
  //   },

  //   listbox: {
  //     maxHeight: 200,
  //     overflowY: "auto",
  //     scrollbarWidth: "thin",
  //     scrollbarColor: "#C8CDD4 transparent",
  //     "&::-webkit-scrollbar": { width: 6 },
  //     "&::-webkit-scrollbar-thumb": {
  //       backgroundColor: "#C8CDD4",
  //       borderRadius: 8,
  //       minHeight: 24,
  //     },
  //     "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#AEB5BE" },
  //     "&::-webkit-scrollbar-track": { background: "transparent" },
  //     "&::-webkit-scrollbar-button": { display: "none !important" },

  //     "& .MuiAutocomplete-option, \
  //      & .MuiMenuItem-root, \
  //      & .MuiListItem-root, \
  //      & li[role='option'], \
  //      & div[role='option']": {
  //       borderBottom: "none !important",
  //     },

  //     "& .MuiDivider-root": { display: "none !important" },
  //   },

  //   countPill: {
  //     display: "inline-flex",
  //     alignItems: "center",
  //     justifyContent: "center",
  //     minWidth: 18, // flexible for +10, +100
  //     padding: "0 6px",
  //     height: 16,
  //     borderRadius: 16,
  //     backgroundColor: "#F0F5F8",
  //     color: "#203662",
  //     fontWeight: 700,
  //     fontSize: 11,
  //     lineHeight: "16px",
  //     userSelect: "none",
  //   },

  //   endPill: { marginRight: 6 },

  //   clearBtn: {
  //     padding: 4,
  //     borderRadius: 6,
  //     "& svg": { fontSize: 18, color: "#203662" },
  //     "&:hover svg": { opacity: 0.9 },
  //   },

  //   dropdownBtn: {
  //     padding: 4,
  //     borderRadius: 6,
  //     "& svg": { fontSize: 20, color: "#203662" },
  //     "&:hover svg": { opacity: 0.9 },
  //   },

  //   endAdornmentContainer: {
  //     position: "absolute",
  //     right: 4,
  //     top: "50%",
  //     transform: "translateY(-50%)",
  //     display: "flex",
  //     alignItems: "center",
  //     gap: 2,
  //     pointerEvents: "auto",
  //   },
  // }));
  const useStyles = makeStyles(() => ({
    paper: { overflowY: "hidden", fontSize: 12 },

    autocomplete: {
      fontFamily: "Nunito, sans-serif !important",

      // expose a CSS var to reserve space for the right adornment (pill + X + chevron)
      "& .MuiAutocomplete-inputRoot": {
        "--end-gap": 96,
        height: 42,
        marginBottom: 16,
        fontSize: 12,
        flexWrap: "nowrap",
        position: "relative",
        boxSizing: "border-box",
      },

      "& .MuiFilledInput-input::placeholder": {
        color: "#8A8A8A",
        opacity: 1,
      },

      "& .MuiFilledInput-root": {
        backgroundColor: "#ffffff",
        height: 42,
        fontSize: 12,
        border: "solid 1px #d4d4d4",
        paddingRight: "calc(var(--end-gap) * 1px) !important",
        paddingLeft: "8px !important",
        borderRadius: 6,
        paddingBottom: 0,
        paddingTop: 10,
        display: "flex",
        alignItems: "flex-start",
        cursor: "text",
        boxSizing: "border-box",
      },

      "& .MuiFilledInput-root:hover": { backgroundColor: "#ffffff" },

      "& .MuiFilledInput-input": {
        lineHeight: "20px",
        height: 20,
        transition: "none",
        paddingRight: 5,
        padding: "0 !important",
        color: "#000000",
        marginTop: 8,
        boxSizing: "border-box",
        minWidth: 0,
      },

      "& .MuiAutocomplete-input": { minWidth: 0 },

      "& .MuiInputLabel-formControl": { top: "-4px", zIndex: 1 },

      "& .MuiFilledInput-underline :focus": { borderBottom: "none" },
      "& .MuiFilledInput-underline:before": { borderBottom: "none" },
      "& .MuiFilledInput-underline:after": { borderBottom: "none" },
      "& .MuiFilledInput-underline:hover:before": { borderBottom: "none" },

      "& .MuiSelect-select:focus": { borderRadius: 6 },

      "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
        transform: " translate(9px, 12px) scale(0.75)",
      },

      "& .MuiInputBase-root.Mui-disabled": { border: "none !important" },

      "& .MuiAutocomplete-clearIndicator": { display: "none" },
      "& .MuiAutocomplete-startAdornment": {
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap",
        gap: 4,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        paddingRight: "calc(var(--end-gap) * 1px)",
        pointerEvents: "none",
      },

      "& .MuiAutocomplete-tag": {
        backgroundColor: "#e3f2fd",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        padding: 0,
        margin: 0,
      },

      "& .MuiFormLabel-asterisk": { color: "#e32b35" },

      "& .MuiFormLabel-root": {
        fontSize: 12,
        color: "#1E1E1E",
        fontWeight: 400,
        fontFamily: "Nunito, sans-serif !important",
        top: "-5.7px !important",
        zIndex: 2,
      },

      "& .MuiAutocomplete-endAdornment": { display: "none" },
      "& .MuiAutocomplete-popupIndicator": { display: "none" },
    },

    selectedText: {
      color: "#231F20",
      fontSize: 12,
      fontFamily: "Nunito, sans-serif",
      fontWeight: "normal",
      marginRight: 4,
      lineHeight: "20px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%", // no calc here
      marginTop: 8,
      height: 20,
      display: "flex",
      alignItems: "center",
      marginLeft: 0,
      zIndex: 3,
      pointerEvents: "none",
    },

    listbox: {
      maxHeight: 200,
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: "#C8CDD4 transparent",
      "&::-webkit-scrollbar": { width: 6 },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#C8CDD4",
        borderRadius: 8,
        minHeight: 24,
      },
      "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#AEB5BE" },
      "&::-webkit-scrollbar-track": { background: "transparent" },
      "&::-webkit-scrollbar-button": { display: "none !important" },

      "& .MuiAutocomplete-option, \
       & .MuiMenuItem-root, \
       & .MuiListItem-root, \
       & li[role='option'], \
       & div[role='option']": {
        borderBottom: "none !important",
      },

      "& .MuiDivider-root": { display: "none !important" },
    },

    countPill: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: 18,
      padding: "0 6px",
      height: 16,
      borderRadius: 16,
      backgroundColor: "#F0F5F8",
      color: "#203662",
      fontWeight: 700,
      fontSize: 11,
      lineHeight: "16px",
      userSelect: "none",
    },

    endPill: { marginRight: 6 },

    clearBtn: {
      padding: 4,
      borderRadius: 6,
      "& svg": { fontSize: 18, color: "#203662" },
      "&:hover svg": { opacity: 0.9 },
    },

    dropdownBtn: {
      padding: 4,
      borderRadius: 6,
      "& svg": { fontSize: 20, color: "#203662" },
      "&:hover svg": { opacity: 0.9 },
    },

    endAdornmentContainer: {
      position: "absolute",
      right: 4,
      top: "50%",
      transform: "translateY(-50%)",
      display: "flex",
      alignItems: "center",
      gap: 2,
      pointerEvents: "auto",
    },
  }));

  const classes = useStyles();

  const handleClearAll = useCallback(() => {
    setIndicationValue([]);
    onChange([]);
  }, [onChange]);

  const handleSelectionChange = useCallback(
    (isChecked, option) => {
      const currentValue = indicationValue || [];
      const newValue = isChecked
        ? currentValue.find((el) => el.id === option.id)
          ? currentValue
          : [...currentValue, option]
        : currentValue.filter((item) => item.id !== option.id);

      setIndicationValue(newValue);
      onChange(newValue);
    },
    [indicationValue, onChange]
  );

  const getInputProps = (params) => {
    const count = Math.max(0, (indicationValue?.length || 0) - 1);

    return {
      ...params.InputProps,
      endAdornment: (
        <div className={classes.endAdornmentContainer}>
          {count > 0 && (
            <span
              className={`${classes.countPill} ${classes.endPill}`}
            >{`+${count}`}</span>
          )}
          {indicationValue && indicationValue.length > 0 && (
            <IconButton
              className={classes.clearBtn}
              size="small"
              aria-label="Clear selected indications"
              onMouseDown={(e) => e.preventDefault()}
              onClick={(e) => {
                e.stopPropagation();
                handleClearAll();
              }}
            >
              <CloseIcon style={{ width: 12, height: 12 }} />
            </IconButton>
          )}
          <IconButton
            className={classes.dropdownBtn}
            size="small"
            aria-label="Toggle dropdown"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpen(!open);
            }}
          >
            <ExpandMore
              style={{
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
                width: 12,
                height: 12,
              }}
            />
          </IconButton>
        </div>
      ),
    };
  };

  return (
    <div style={{ width: "100%", minWidth: 196, marginTop: 0 }}>
      <Autocomplete
        inputValue={open ? searchText : ""}
        onInputChange={(e, v, reason) => {
          if (reason !== "reset") setSearchText(v);
        }}
        disabled={disabled}
        limitTags={1}
        id="indication-search-and-select"
        style={{ width: "100%" }}
        open={open}
        onClose={(event, reason) => {
          if (reason !== "toggleInput") {
            setOpen(false);
          }
        }}
        options={optionsToDisplay}
        value={indicationValue || []}
        className={`${classes.autocomplete} ${classes.paper}`}
        getOptionLabel={(option) => option.displayName}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        renderInput={(params) => (
          <TextField
            id="tf-indication-search-select"
            {...params}
            label={label}
            variant="filled"
            onChange={(e) => setSearchText(e.target.value)}
            required={required}
            onClick={() => setOpen(true)}
            inputProps={{
              ...params.inputProps,
              autoComplete: "off",
              value: searchText,
              placeholder: open ? "Search & Select" : "",
              onClick: (e) => {
                e.stopPropagation();
                setOpen(true);
              },
            }}
            InputProps={getInputProps(params)}
          />
        )}
        renderTags={(value) => {
          if (!open && value?.length > 0) {
            const firstOption = value[0];
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "nowrap",
                }}
              >
                <span className={classes.selectedText}>
                  {firstOption.displayName?.length > 15
                    ? costomEllipsis(firstOption.displayName, 15)
                    : firstOption.displayName}
                </span>
              </div>
            );
          }
          return null;
        }}
        multiple
        disableCloseOnSelect
        ListboxComponent={ListboxComponentCustom}
        ListboxProps={{
          className: classes.listbox,
          alreadySelected: indicationValue,
          optionsToDisplay: optionsToDisplay || [],
          open,
          handleSelectionChange,
          onMouseDown: (e) => e.preventDefault(),
        }}
      />
    </div>
  );
};

const ListboxComponentCustom = React.forwardRef(function ListboxComponentCustom(
  {
    alreadySelected,
    optionsToDisplay,
    open,
    handleSelectionChange,
    style,
    ...listboxProps
  },
  ref
) {
  return (
    <div ref={ref} {...listboxProps} style={style}>
      <MultiSelectList
        data={optionsToDisplay}
        open={open}
        handleSelection={(isChecked, option) =>
          handleSelectionChange(isChecked, option)
        }
        selected={alreadySelected || []}
      />
    </div>
  );
});

export default IndicationFilter;
